import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  giftTitle: "",
  giftDescription: "",
};

const FreeServiceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setGiftTitle: (state, action) => {
      state.giftTitle = action.payload;
    },
    setGiftDescription: (state, action) => {
      state.giftDescription = action.payload;
    },
    setFreeService: (state, action) => {
      const { giftTitle, giftDescription } = action.payload;
      state.giftTitle = giftTitle;
      state.giftDescription = giftDescription;
    },
  },
});

export const { setGiftTitle, setGiftDescription, setFreeService } =
  FreeServiceSlice.actions;
export default FreeServiceSlice.reducer;
